import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { galleryData } from "../data/galleryData";
const Gallery = () => {
  const [index, setIndex] = useState(-1);

  // Inhe aap MongoDB se fetch karke objects ki array bana sakte hain
  const images = [
    { src: "/gallery-1.jpg", title: "Shrimad Bhagwat Katha" },
    { src: "/gallery-2.jpg", title: "Vrindavan Satsang" },
    { src: "/gallery-3.jpg", title: "Gau Sewa" },
    { src: "/gallery-4.jpg", title: "Deepotsav" },
    { src: "/gallery-5.jpg", title: "Mathura Darshan" },
    { src: "/gallery-6.jpg", title: "Evening Aarti" },
  ];

  return (
    <section id="gallery" style={{ backgroundColor: "#fffaf5" }}>
      <Container className="py-lg-5">
        <div className="text-center mb-5">
          <h6 className="text-warning fw-bold text-uppercase tracking-widest">
            Aura of Devotion
          </h6>
          <h2 className="font-serif display-5" style={{ color: "#431407" }}>
            Darshan Gallery
          </h2>
          <div
            className="mx-auto bg-warning mt-2"
            style={{ height: "3px", width: "80px" }}
          ></div>
        </div>

        <Row className="g-4">
          {galleryData.map((img, i) => (
            <Col md={4} key={i}>
              <motion.div
                whileHover={{ y: -10 }}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
              >
                <Card
                  className="border-0 rounded-0 overflow-hidden shadow gallery-card position-relative"
                  style={{ cursor: "pointer" }}
                  onClick={() => setIndex(i)}
                >
                  <div className="gallery-overlay d-flex align-items-center justify-content-center">
                    <span className="text-white fw-bold tracking-widest border border-white px-3 py-2">
                      VIEW DARSHAN
                    </span>
                  </div>
                  <div style={{ height: "350px" }}>
                    <img
                      src={img.image}
                      alt={img.title}
                      className="w-100 h-100 object-cover transform-transition"
                    />
                  </div>
                  <div className="p-3 bg-white text-center border-top border-warning-subtle">
                    <small className="text-muted font-serif italic">
                      {img.title}
                    </small>
                  </div>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>

        {/* --- LIGHTBOX (Fullscreen View) --- */}
        <Lightbox
          index={index}
          open={index >= 0}
          close={() => setIndex(-1)}
          slides={galleryData.map((img) => ({ src: img.image }))}
          // Yahan aap Zoom, Thumbnails plugins bhi add kar sakte hain
        />
      </Container>

      <style>{`
        .gallery-card .gallery-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(67, 20, 7, 0.6);
          opacity: 0;
          transition: 0.4s ease;
          z-index: 2;
        }
        .gallery-card:hover .gallery-overlay {
          opacity: 1;
        }
        .gallery-card:hover .transform-transition {
          transform: scale(1.1);
        }
        .transform-transition {
          transition: transform 0.8s ease;
        }
        /* Customize Lightbox Maroon/Gold Theme */
        .yarl__container {
          background-color: rgba(0, 0, 0, 0.95);
        }
        .yarl__button {
           color: #DAA520;
        }
      `}</style>
    </section>
  );
};

export default Gallery;
